import React from 'react';
import PropTypes from 'prop-types';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { defaultDecimalPlaces } from 'constants/numeric';
import { getDynamicFieldControlType } from 'utils/functions';
import { Grid } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';

const DocumentPropertiesGroup = ({ properties, onPropertyChange, loadPropertyDetails, readOnly }) => {
  return (
    <Grid container spacing={3}>
      {properties &&
        properties.map(prop => (
          <Grid item xs={12} md={6} key={prop.propertyId}>
            <DynamicField
              id={prop.documentPropertyId.toString()}
              value={prop.propValue || ''}
              controlType={getDynamicFieldControlType(prop.typeCode)}
              inputProps={{ decimalScale: prop.decimalPlaces ?? defaultDecimalPlaces }}
              label={prop.name}
              required={prop.mandatory}
              disabled={!prop.allowWrite || readOnly}
              onChange={value => onPropertyChange(prop.documentPropertyId, value)}
              valueKey={'value'}
              labelKey={'label'}
              loadOptions={() => loadPropertyDetails(prop.documentPropertyId)}
              error={!isValid(prop.validation.propValue)}
              helperText={getErrors(prop.validation.propValue)}
              simpleValue={true}
            />
          </Grid>
        ))}
    </Grid>
  );
};

DocumentPropertiesGroup.propTypes = {
  properties: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  loadPropertyDetails: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};

export default DocumentPropertiesGroup;
